export const FETCHED_STAFF = 'FETCHED_STAFF';
export const FETCHED_STAFF_MEMBER = 'FETCHED_STAFF_MEMBER';
export const CREATED_STAFF_MEMBER = 'CREATED_STAFF_MEMBER';
export const UPDATED_STAFF_MEMBER = 'UPDATED_STAFF_MEMBER';
export const FETCHED_STAFF_TRANSLATIONS = 'FETCHED_STAFF_TRANSLATIONS';
export const FETCHED_STAFF_TRANSLATION = 'FETCHED_STAFF_TRANSLATION';
export const CREATED_STAFF_TRANSLATION = 'CREATED_STAFF_TRANSLATION';
export const UPDATED_STAFF_TRANSLATION = 'UPDATED_STAFF_TRANSLATION';
export const DELETED_STAFF_TRANSLATION = 'DELETED_STAFF_TRANSLATION';
export const DELETED_STAFF = 'DELETED_STAFF';
export const DISABLED_STAFF_MEMBER = 'DISABLED_STAFF_MEMBER';
export const ENABLED_STAFF_MEMBER = 'ENABLED_STAFF_MEMBER';
export const FETCHED_JOB_TITLES = 'FETCHED_JOB_TITLES';
export const FETCHED_STAFF_SITES = 'FETCHED_STAFF_SITES';
export const FETCHED_STAFF_TITLES = 'FETCHED_STAFF_TITLES';
export const FETCHED_STAFF_TEAMS = 'FETCHED_STAFF_TEAMS';
export const FETCHED_PROJECTS_BY_DESTINATION = 'FETCHED_PROJECTS_BY_DESTINATION';
export const SELECT_STAFF_TITLE = 'SELECT_STAFF_TITLE';
export const SELECT_JOB_TITLES = 'SELECT_JOB_TITLES';
export const SELECT_STAFF_NAME = 'SELECT_STAFF_NAME';
export const SELECT_STAFF_FIRST_NAME = 'SELECT_STAFF_FIRST_NAME';
export const SELECT_STAFF_TEAMS = 'SELECT_STAFF_TEAMS';
export const SELECT_STAFF_SITES = 'SELECT_STAFF_SITES';
export const SELECT_STAFF_DESTINATIONS = 'SELECT_STAFF_DESTINATIONS';
export const SELECT_STAFF_DESCRIPTION = 'SELECT_STAFF_DESCRIPTION';
export const PROJECT_REMOVE_FOR_DESTINATION = 'PROJECT_REMOVE_FOR_DESTINATION';
export const PROJECT_ADD_FOR_DESTINATION = 'PROJECT_ADD_FOR_DESTINATION';

/* STAFF IMAGE */
export const ADD_IMAGE = 'ADD_IMAGE';
export const DELETE_IMAGE = 'DELETE_IMAGE';
export const UPDATE_CROPPED_IMAGE = 'UPDATE_CROPPED_IMAGE';
export const UPDATE_IMAGE_META = 'UPDATE_IMAGE_META';


// WEBPACK FOOTER //
// ./src/containers/staff/types.js